import "./SroSection.css";

// ---------------------------------------------------------------------------
// Данные СРО (исправленные тексты)
// ---------------------------------------------------------------------------
const SRO_LIST = [
  {
    letter: "П",
    title: "Проектное СРО",
    subtitle: "Подготовка проектной документации",
    org: "Ассоциация проектных организаций «Стройспецпроект»",
    memberNo: "П-153-006670509242-1580",
    memberSince: "12.04.2023",
  },
  {
    letter: "С",
    title: "Строительное СРО",
    subtitle: "Строительство, реконструкция, капитальный ремонт",
    org: "Союз «Уральское объединение строителей» (УОС)",
    memberNo: "3767",
    memberSince: "18.04.2023",
  },
];

// ---------------------------------------------------------------------------
// Карточка одного СРО
// ---------------------------------------------------------------------------
function SroCard({ letter, title, subtitle, org, memberNo, memberSince }) {
  const rows = [
    { label: "СРО",                         value: org },
    { label: "Регистрационный № члена",      value: memberNo },
    { label: "Дата вступления",              value: memberSince },
  ];

  return (
    <div className="sro-card">
      {/* Шапка: буква + заголовок */}
      <div className="sro-card__header">
        <div className="sro-card__badge">{letter}</div>
        <div>
          <h3 className="sro-card__title">{title}</h3>
          <p className="sro-card__subtitle">{subtitle}</p>
        </div>
      </div>

      {/* Таблица реквизитов */}
      <dl className="sro-card__table">
        {rows.map((row) => (
          <div key={row.label} className="sro-card__row">
            <dt className="sro-card__label">{row.label}</dt>
            <dd className="sro-card__value">{row.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Основной компонент
// ---------------------------------------------------------------------------
export default function SroSection() {
  return (
    <section id="sro" className="sro-section">
      <div className="sro-layout">

        {/* ── Левая колонка: текст ── */}
        <div className="sro-left">
          <div className="sro-eyebrow">Лицензии и допуски</div>

          <h2 className="sro-title">
            Работаем<br />
            с <span className="sro-title__accent">СРО</span>
          </h2>

          <p className="sro-text">
            ООО «АЙТИ СИСТЕМЫ» — член проектного и строительного СРО.
            Выполняем проектирование, строительство и монтаж сетей связи,
            СКС, СОТ, СКУД, серверных и слаботочных систем для коммерческих
            и промышленных объектов.
          </p>
        </div>

        {/* ── Правая колонка: карточки СРО ── */}
        <div className="sro-right">
          {SRO_LIST.map((sro, idx) => (
            <div key={sro.letter}>
              {idx > 0 && <div className="sro-divider" />}
              <SroCard {...sro} />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}